import setting from '../setting';

export const Banner = [{
    'title': '质量方针',
    'data': '以人为本,技术领先,快速反应,以好的质量和交付赢得客户的信赖'
},{
    'title': '质量原则',
    'data': '不要未经客户批准私自变更 不要隐瞒质量问题</br>不要违反标准作业 不要拒绝质量改善</br>不要为质量问题找借口 不要篡改质量数据</br>不要跳工序作业 不要让评审未通过的项目量产</br>不要引入未通过审核的供应商 不要使用未经充分验证的物料'
}];

// type: 'router'   //内部跳转 无token
// type: 'link'    //外链跳转+token
export const Header = [
    {
        id: 1000,
        title: '首页',
        url: '/#/',
        type: 'router',
        subMenuList: undefined
    },
    {
        id: 2000,
        title: '客户质量',
        subMenuList: [
            {
                id: 20001,
                url: 'http://120.77.157.65:8027/8d/home',
                type: 'link',
                title: '8D',
                code: '8d'
            }, 
            {
                id: 20002,
                url: 'http://120.77.157.65:8027/score/home',
                type: 'link',
                title: '客户评价',
                code: 'score'
            },
            {
                id: 20003,
                url: 'http://120.77.157.65:8027/customer-complaints',
                type: 'link',
                title: '客户投诉管理',
                code: 'het2'
            },
            {
                id: 20004,
                url: 'http://120.77.157.65:8027/customer-satisfaction/customer-sat-order',
                type: 'link',
                title: '客户满意度管理',
                code: 'het2'
            },
            {
                id: 20005,
                url: 'http://120.77.157.65:8027/customer-demand/customer-demand',
                type: 'link',
                title: '客户质量需求管理',
                code: 'het2'
            }
        ]
    },
    {
        id: 3000,
        title: '新产品开发质量',
        subMenuList: [
            {
                id: 30001,
                url:  'http://120.77.157.65:8511/project-list',
                type: 'link',
                title: 'NPI项目管理',
                code: 'npi'
            },
            {
                id: 30002,
                url:  'http://120.77.157.65:8511/risk-list',
                type: 'link',
                title: '风险管理(FMEA追踪)',
                code: 'npi'
            },
            {
                id: 30003,
                url:  'http://120.77.157.65:8511/test-plan',
                type: 'link',
                title: '测试验证管理(DVP&R)',
                code: 'npi'
            },
            {
                id: 30004,
                url:  'http://120.77.157.65:8511/ppap-list',
                type: 'link',
                title: '新物料PPAP管理',
                code: 'npi'
            },
            {
                id: 30005,
                url:  'http://120.77.157.65:8511/deliverable',
                type: 'link',
                title: '阶段交付物管理',
                code: 'npi'
            },
            {
                id: 30006,
                url:  'http://120.77.157.65:8511/gate-review',
                type: 'link',
                title: 'Gate评审管理',
                code: 'npi'
            },
            {
                id: 30007,
                url:  'http://120.77.157.65:8511/issue-list',
                type: 'link',
                title: '问题管理',
                code: 'npi'
            },
            {
                id: 30008,
                url:  'http://120.77.157.65:8511/change-list',
                type: 'link',
                title: '变更管理',
                code: 'npi'
            }
        ]
    },
    {
        id: 4000,
        title: '生产过程质量',
        subMenuList: [
            {
                id: 40001,
                url:  'http://120.77.157.65:8028/iqc/order-list',
                type: 'link',
                title: 'IQC',
                code: 'iqc'
            },
            {
                id: 40002,
                url: 'http://120.77.157.65:8028/fai/order-list',
                type: 'link',
                title: '首末件',
                code: 'fai'
            },
            {
                id: 40004,
                url: 'http://120.77.157.65:8028/ipqc/order-list',
                type: 'link',
                title: 'IPQC',
                code: 'ipqc'
            },
            {
                id: 40005,
                url: 'http://120.77.157.65:8028/fqc/order-list',
                type: 'link',
                title: 'FQC',
                code: 'fqc'
            },
            {
                id: 40006,
                url: 'http://120.77.157.65:8028/oqc/order-list',
                type: 'link',
                title: 'OQC',
                code: 'oqc'
            },
            {
                id: 40007,
                url: 'http://120.77.157.65:8028/q-tack/mo',
                type: 'link',
                title: 'Q追溯',
                code: 'q-track'
            },
            {
                id: 40008,
                url: 'http://120.77.157.65:8027/stop-line/line-suspension',
                type: 'link',
                title: '停线管理',
                code: 'stop-line'
            },
            {
                id: 40009,
                url: 'http://120.77.157.65:8027/charts/iqc_page1_daily.html',
                type: 'link',
                title: '质量看板',
                code: 'iqc—dashboard'
            }
        ]
    },
    {
        id: 5000,
        title: '供方质量',
        subMenuList: [
            {
                id: 50001,
                url: 'http://120.77.157.65:8027/supplier-archive',
                type: 'link',
                title: '供应商档案管理',
                code: 'supplier-archive'
            },
            {
                id: 5000101,
                url: 'http://120.77.157.65:8027/supplier-development-create',
                type: 'link',
                title: '供应商导入',
                code: 'supplier-introduction'
            },
            {
                id: 50002,
                url: 'http://120.77.157.65:8027/secondary-supply-development',
                type: 'link',
                title: '二供开发',
                code: 'supplier-reintroduction'
            },
            {
                id: 50004,
                url: 'http://120.77.157.65:8027/supplier-exit',
                type: 'link',
                title: '供应商退出',
                code: 'supplier-exit'
            },
            {
                id: 50005,
                url: 'http://120.77.157.65:8027/performance-monitoring',
                type: 'link',
                title: '供应商绩效评估',
                code: 'supplier-performance'
            },
            {
                id: 50006,
                url: 'http://120.77.157.65:8027/supplier-annual-audit/supplier-audit-plan',
                type: 'link',
                title: '供应商审核',
                code: 'supplier-audit'
            }
        ]
    },
    {
        id: 6000,
        title: '质量体系',
        subMenuList: [
            {
                id: 60001,
                url: 'http://120.77.157.65:8027/quality-work-plan/home',
                type: 'link',
                title: '质量工作计划',
                code: 'work-plan'
            },
            {
                id: 60002,
                url: 'http://120.77.157.65:8027/quality-target/home',
                type: 'link',
                title: '质量目标',
                code: 'quality-target'
            },
            {
                id: 60003,
                url: 'http://120.77.157.65:8027/internal-audit/home',
                type: 'link',
                title: '内部审核管理',
                code: 'het2'
            },
            {
                id: 60004,
                url: 'http://120.77.157.65:8027/external-audit/home',
                type: 'link',
                title: '外部审核管理',
                code: 'het2'
            },
            {
                id: 60005,
                url: 'http://120.77.157.65:8027/zx-quality-activity/dashboard',
                type: 'link',
                title: '专项质量活动管理',
                code: 'het2'
            },
            {
                id: 60006,
                url: 'http://120.77.157.65:8027/quality-cost/cost-summary',
                type: 'link',
                title: '质量成本管理',
                code: 'het2'
            },
            {
                id: 60007,
                url: 'http://120.77.157.65:8027/quality-reward-punishment/home/group',
                type: 'link',
                title: '质量奖惩',
                code: 'het2'
            },
            {
                id: 60008,
                url: 'http://120.77.157.65:8027/quality-person/quality-person',
                type: 'link',
                title: '质量人员管理',
                code: 'het2'
            },
            {
                id: 60009,
                url:  'http://120.77.157.65:8027/new-dcc/dashboard',
                type: 'link',
                title: 'DCC',
                code: 'het2'
            },
            {
                id: 60010,
                url: 'http://120.77.157.65:8027/management-review-plan',
                type: 'link',
                title: '管理评审',
                code: 'het2'
            },
            {
                id: 60011,
                title: '持续改进管理',
                subMenuList: [
                    {
                        id: 6000111,
                        url: 'http://120.77.157.65:8027/ci-project/home',
                        type: 'link',
                        title: '持续改进项目管理',
                        code: 'het2'
                    },
                    {
                        id: 6000112,
                        url: 'http://120.77.157.65:8027/qcc/home/index',
                        type: 'link',
                        title: 'QCC',
                        code: 'het2'
                    },
                    {
                        id: 6000113,
                        url: 'http://120.77.157.65:8027/6sigma/home/index',
                        type: 'link',
                        title: '6Sigma',
                        code: 'het2'
                    },
                    {
                        id: 6000114,
                        url: 'http://120.77.157.65:8027/gold-idea/proposal-manage/my-proposal',
                        type: 'link',
                        title: '金点子',
                        code: 'het2'
                    },
                    {
                        id: 6000115,
                        url: 'http://120.77.157.65:8027/problem-registration',
                        type: 'link',
                        title: 'QIIS',
                        code: 'het2'
                    }
                ]
            },
        ]
    },
    {
        id: 7000,
        title: '知识经验库',
        subMenuList: [
            {
                id: 70001,
                url: 'http://120.77.157.65:8027/lesson-learn/lesson-learn-order',
                type: 'link',
                title: 'Lesson Learn',
                code: 'het2'
            }
        ]
    },
    {
        id: 8000,
        url: 'http://47.106.218.137:3838/union/labsys/',
        title: '实验室管理',
        type: 'link',
        subMenuList: undefined
    },
    {
        id: 9000,
        title: '检验设备管理',
        url: 'http://120.77.157.65:8027/asset-device/asset-device',
        type: 'link',
        subMenuList: undefined
    },
    {
        id: 10000,
        title: '统计分析',
        subMenuList: [
            {
                id: 100001,
                url: 'http://120.77.157.65:8027/spc/data-acquisition',
                type: 'link',
                title: 'SPC',
                code: 'het2'
            },
            {
                id: 100002,
                url: '',
                type: 'link',
                title: '统计工具',
                code: 'het2'
            }
        ]
    },
        {
        id: 11000,
        title: '客户定制',
        subMenuList: [
            {
                id: 100001,
                url: 'http://118.89.119.88:9992/#/login',
                type: 'link',
                title: '智新科技QMS',
                code: 'het2'
            },
            {
                id: 100002,
                url: 'https://www.wxmmi.com/home/index',
                type: 'link',
                title: 'MMI',
                code: 'het2'
            },
            {
                id: 100003,
                url: 'http://120.77.157.65:8079/index',
                type: 'link',
                title: '凯德',
                code: 'het2'
            }
        ]
    }
]

export const Footer = [
    {
        id: 100,
        title: '相关链接',
        itemList: [{
            id: 1001,
            url: 'http://10.12.17.71:8888',
            title: 'MES',
            type: 'link'
        },
        {
            id: 1002,
            url: 'http://10.16.16.81:8888',
            title: 'WMS',
            type: 'link'
        },
        {
            id: 1003,
            url: 'https://portal.szhittech.com/',
            title: 'OA',
            type: 'link'
        },
        {
            id: 1004,
            url: 'http://ehr.szhittech.com',
            title: 'EHR',
            type: 'link'
        }]
    },
    {
        id: 200,
        title: '支持',
        itemList: [{
            id: 2001,
            url: setting.ADMIN_LINK,
            title: '后台管理系统',
            type: 'link'
        },
        {
            id: 2002,
            url: setting.HELP_LINK,
            title: '帮助中心',
            type: 'link'
        },
        {
            id: 2003,
            url: 'https://www.yuanjietech.cloud/feedback/?project=het',
            title: '意见反馈',
            type: 'link'
        }]
    },
    {
        id: 300,
        title: '关于',
        itemList: [{
            id: 3001,
            url: 'https://www.szhittech.com/',
            title: '关于我们',
            type: 'link'
        }]
    },
    {
        id: 400,
        title: '关注和而泰',
        itemList: [{
            id: 4001,
            url: '#',
            title: '微信公众号',
            type: 'img'
        }]
    }
]

export const AppTabList = [
    {
        appTabId: 50000,
        appTabName: '客户质量',
        appTabIcon: 'icon-customer',
        appList: [{
            id: 500001,
            title: '8D',
            cover: require('@/assets/img/app_new/8d.jpg'),
            url: setting.EIGHTD_LINK,
            code: '8d',
            span: '25%',
            status: 1
        },
        {
            id: 500002,
            title: '客户评价',
            cover: require('@/assets/img/app_new/CS.jpg'),
            url: setting.SCORE_LINK,
            code: 'score',
            span: '25%',
            status: 1
        },
        {
            id: 500003,
            title: '客退管理',
            cover: require('@/assets/img/app_new/THH.jpg'),
            url: setting.HET_BASE + 'customer-refund/customer-return-order',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 500004,
            title: '顾客满意度管理',
            cover: require('@/assets/img/app_new/CCM.jpg'),
            url: setting.HET_BASE + 'customer-satisfaction/customer-sat-order',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 500005,
            title: '客户质量需求管理',
            cover: require('@/assets/img/app_new/CQRM.jpg'),
            url: setting.HET_BASE + 'customer-demand/customer-demand',
            code: 'het2',
            span: '25%',
            status: 1
        }]
    },
    {
        appTabId: 51000,
        appTabName: '新产品开发质量',
        appTabIcon: 'icon-dev',
        appList: [{
            id: 510001,
            title: 'DFX',
            cover: require('@/assets/img/app_new/DFX.jpg'),
            url: setting.DFX_LINK,
            code: 'dfx',
            span: '50%',
            status: 1
        },
        {
            id: 510002,
            title: '设计质量管理',
            cover: require('@/assets/img/app_new/DQM.jpg'),
            url: '',
            code: 'het2',
            span: '50%',
            status: 0
        }]
    },
    {
        appTabId: 52000,
        appTabName: '生产过程质量',
        appTabIcon: 'icon-process',
        appList: [{
            id: 520001,
            title: 'CAR',
            cover: require('@/assets/img/app_new/CAR.jpg'),
            url: setting.CAR_LINK,
            code: 'car',
            span: '25%',
            status: 1
        },
        {
            id: 520002,
            title: '首件',
            cover: require('@/assets/img/app_new/FPC.jpg'),
            url: setting.HET_BASE + 'fa/fa-smt-inspection',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520004,
            title: 'SMT-IPQC巡检问题',
            cover: require('@/assets/img/app_new/IPQC.jpg'),
            url: setting.HET_BASE + 'ipqc-smt/ipqc-smt-inspection',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520005,
            title: 'DIP-IPQC巡检问题',
            cover: require('@/assets/img/app_new/IPQC.jpg'),
            url: setting.HET_BASE + 'ipqc-dip/ipqc-dip-inspection',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520006,
            title: 'SMT-IPQC异常问题',
            cover: require('@/assets/img/app_new/IPQC.jpg'),
            url: setting.HET_BASE + 'ipqc-smt-abnormal/ipqc-smt-abnormal',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520007,
            title: 'DIP-IPQC异常问题',
            cover: require('@/assets/img/app_new/IPQC.jpg'),
            url: setting.HET_BASE + 'ipqc-dip-abnormal/ipqc-dip-abnormal',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520008,
            title: 'FQC',
            cover: require('@/assets/img/app_new/FQC.jpg'),
            url: '',
            code: 'het2',
            span: '25%',
            status: 0
        },
        {
            id: 520009,
            title: 'OBA DIP',
            cover: require('@/assets/img/app_new/OBA.jpg'),
            url: setting.HET_BASE + 'oba-dip/oba-dip',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520010,
            title: 'SMT异常管理',
            cover: require('@/assets/img/app_new/OBA.jpg'),
            url: setting.HET_BASE + 'oba-smt/oba-smt-rejected',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520011,
            title: 'OQA',
            cover: require('@/assets/img/app_new/CM.jpg'),
            url: setting.HET_BASE + 'oqa/oqa-shipment',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520013,
            title: '不合格品审理',
            cover: require('@/assets/img/app_new/NG.jpg'),
            url: setting.HET_BASE + 'ng-review/ng-review',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520014,
            title: '风险出货评审',
            cover: require('@/assets/img/app_new/risk-shipment.jpg'),
            url: setting.HET_BASE + 'risk-shipment/risk-shipment',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 520015,
            title: '停机管理',
            cover: require('@/assets/img/app_new/stop-line.jpg'),
            url: setting.HET_BASE + 'stop-line/line-suspension',
            code: 'het2',
            span: '25%',
            status: 1
        }]
    },
    {
        appTabId: 53000,
        appTabName: '供方质量',
        appTabIcon: 'icon-supplier',
        appList: [{
            id: 530001,
            title: '来料检验管理',
            cover: require('@/assets/img/app_new/supplier/IQC.jpg'),
            url: setting.HET_BASE + 'iqc/inspection-data',
            code: 'het2',
            span: '50%',
            status: 1
        },
        {
            id: 530002,
            title: '供方质量管理',
            cover: require('@/assets/img/app_new/supplier/SQM.jpg'),
            url: '',
            code: 'het2',
            span: '25%',
            status: 0
        },
        // {
        //     id: 530003,
        //     title: '供应商绩效考核查询',
        //     cover: require('@/assets/img/app_new/supplier/KPI.png'),
        //     url: '',
        //     code: 'het2',
        //     span: '25%',
        //     status: 0
        // },
        {
            id: 530004,
            title: '元器件FA分析追踪管理',
            cover: require('@/assets/img/app_new/supplier/IQC.jpg'),
            url: setting.HET_BASE + 'yqj-fa-fx-zz/apply-list',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 530005,
            title: '供应商年度审核报告',
            cover: require('@/assets/img/app_new/supplier/IQC.jpg'),
            url: setting.HET_BASE + 'supplier-annual-audit/home',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 530006,
            title: '供应商专项/跟踪审核报告',
            cover: require('@/assets/img/app_new/supplier/IQC.jpg'),
            url: setting.HET_BASE + 'supplier-annual-audit/home',
            code: 'het2',
            span: '50%',
            status: 1
        }]
    },
    {
        appTabId: 54000,
        appTabName: '质量体系',
        appTabIcon: 'icon-iso',
        appList: [{
            id: 540001,
            title: '质量工作计划',
            cover: require('@/assets/img/app_new/quality-system/quality-work-plan.png'),
            url: setting.HET_BASE + 'quality-work-plan/home',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540002,
            title: '质量目标管理',
            cover: require('@/assets/img/app_new/quality-system/quality-target.png'),
            url: setting.HET_BASE + 'quality-target/home',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540003,
            title: '内部审核管理',
            cover: require('@/assets/img/app_new/quality-system/internal-audit.png'),
            url: setting.HET_BASE + 'internal-audit/home',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540004,
            title: '外部审核管理',
            cover: require('@/assets/img/app_new/quality-system/external-audit.png'),
            url: setting.HET_BASE + 'external-audit/home',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540005,
            title: '专项质量活动管理',
            cover: require('@/assets/img/app_new/quality-system/quality-activity.png'),
            url: setting.HET_BASE + 'zx-quality-activity/dashboard',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540006,
            title: '质量成本管理',
            cover: require('@/assets/img/app_new/quality-system/quality-cost.jpg'),
            url: setting.HET_BASE + 'quality-cost/cost-summary',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540007,
            title: '质量奖惩',
            cover: require('@/assets/img/app_new/quality-system/quality-reward-punishment.png'),
            url: setting.HET_BASE + 'quality-reward-punishment/home/group',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540008,
            title: '质量人员管理',
            cover: require('@/assets/img/app_new/quality-system/quality-staff.png'),
            url: setting.HET_BASE + 'quality-person/quality-person',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540009,
            title: '持续改进项目管理',
            cover: require('@/assets/img/app_new/quality-system/improvement.jpg'),
            url: setting.HET_BASE + 'ci-project/home',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540010,
            title: 'QCC',
            cover: require('@/assets/img/app_new/CIM.jpg'),
            url: setting.HET_BASE + 'qcc/home/index',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540011,
            title: '金点子',
            cover: require('@/assets/img/app_new/CIM.jpg'),
            url: setting.HET_BASE + 'gold-idea/proposal-manage/my-proposal',
            code: 'het2',
            span: '25%',
            status: 1
        },
        {
            id: 540012,
            title: '6 Sigma',
            cover: require('@/assets/img/app_new/CIM.jpg'),
            url: setting.HET_BASE + '6sigma/home/index',
            code: 'het2',
            span: '25%',
            status: 1
        }]
    },
    {
        appTabId: 55000,
        appTabName: '实验室管理',
        appTabIcon: 'icon-lab',
        appList: [{
            id: 550001,
            title: '实验室管理',
            cover: require('@/assets/img/app_new/LAB.jpg'),
            url: '',
            code: 'het2',
            span: '25%',
            status: 0
        }]
    }
]


export const AppTabProcessCartoon = {
    appTabId: 52000,
    appTabName: '生产过程质量',
    appTabIcon: 'icon-process',
    appList: [{
        id: 520001,
        title: 'CAR',
        cover: require('@/assets/img/app_cartoon/CAR.png'),
        url: setting.CAR_LINK,
        code: 'het2',
        span: '25%',
        status: 1
    }, 
    {
        id: 520002,
        title: '首件',
        cover: require('@/assets/img/app_cartoon/FPC.png'),
        url: setting.HET_BASE + 'fa/fa-smt-inspection',
        code: 'het2',
        span: '25%',
        status: 0
    }, 
    {
        id: 520004,
        title: 'SMT-IPQC巡检问题',
        cover: require('@/assets/img/app_cartoon/IPQC.png'),
        url: setting.HET_BASE + 'ipqc-smt/ipqc-smt-inspection',
        code: 'het2',
        span: '25%',
        status: 0
    }, 
    {
        id: 520005,
        title: 'DIP-IPQC巡检问题',
        cover: require('@/assets/img/app_cartoon/IPQC.png'),
        url: setting.HET_BASE + 'ipqc-dip/ipqc-dip-inspection',
        code: 'het2',
        span: '25%',
        status: 0
    }, 
    {
        id: 520006,
        title: 'SMT-IPQC异常问题',
        cover: require('@/assets/img/app_cartoon/IPQC.png'),
        url: setting.HET_BASE + 'ipqc-smt-abnormal/ipqc-smt-abnormal',
        code: 'het2',
        span: '25%',
        status: 0
    }, 
    {
        id: 520007,
        title: 'DIP-IPQC异常问题',
        cover: require('@/assets/img/app_cartoon/IPQC.png'),
        url: setting.HET_BASE + 'ipqc-dip-abnormal/ipqc-dip-abnormal',
        code: 'het2',
        span: '25%',
        status: 0
    },
    {
        id: 520008,
        title: 'FQC',
        cover: require('@/assets/img/app_cartoon/FQC.png'),
        url: '',
        code: 'het2',
        span: '25%',
        status: 0
    },
    {
        id: 520009,
        title: 'OBA DIP',
        cover: require('@/assets/img/app_cartoon/OBA.png'),
        url: setting.HET_BASE + 'oba-dip/oba-dip',
        code: 'het2',
        span: '25%',
        status: 0
    },
    {
        id: 520010,
        title: 'SMT异常管理',
        cover: require('@/assets/img/app_cartoon/OBA.png'),
        url: setting.HET_BASE + 'oba-smt/oba-smt-rejected',
        code: 'het2',
        span: '25%',
        status: 0
    },
    {
        id: 520011,
        title: 'OQA',
        cover: require('@/assets/img/app_cartoon/CM.png'),
        url: setting.HET_BASE + 'oqa/oqa-shipment',
        code: 'het2',
        span: '25%',
        status: 0
    },
    {
        id: 520013,
        title: '不合格品审理',
        cover: require('@/assets/img/app_cartoon/NG.png'),
        url: setting.HET_BASE + 'ng-review/ng-review',
        code: 'het2',
        span: '25%',
        status: 0
    },
    {
        id: 520014,
        title: '风险出货评审',
        cover: require('@/assets/img/app_cartoon/risk-shipment.png'),
        url: setting.HET_BASE + 'risk-shipment/risk-shipment',
        code: 'het2',
        span: '25%',
        status: 0
    }, 
    {
        id: 520015,
        title: '停机管理',
        cover: require('@/assets/img/app_cartoon/stop-line.png'),
        url: setting.HET_BASE + 'stop-line/line-suspension',
        code: 'het2',
        span: '25%',
        status: 0
    }]
}

export const LangList = [
    {
        code: 'zh',
        name: '中文'
    },{
        code: 'en',
        name: 'English'
    }
]
